(function() {
  try {
    const currentPath = window.location.pathname;

    // Explicit redirects map: target URL -> matching patterns
    const redirectMap = [
      {
        target: '/products/cloak-tuck-3-5-iwb-holster',
        patterns: [
          /^\/products\/cloak-tuck-3-5-iwb-holster-for-.+$/i,
          /^\/products\/cloak-tuck-3-5-for-.+$/i
        ]
      },
      {
        target: '/products/cloak-chest-holster',
        patterns: [
          /^\/products\/cloak-chest-holster-for-.+$/i,
          /^\/products\/cloak-chest-for-.+$/i
        ],
        exclude: [
          /taurus-revolver/i,
          /ruger-lcr/i,
          /ruger-redhawk/i,
          /ruger-gp100/i,
          /revolver/i
        ]
      },
      {
        target: '/products/cloak-chest-holster-for-revolvers',
        patterns: [
          /^\/products\/cloak-chest-holster-for-revolvers?-for-.+$/i,
          /^\/products\/cloak-chest-revolver-for-.+$/i,
          /^\/products\/cloak-chest-holster-for-revolvers?-.+$/i,
          /^\/products\/cloak-chest-revolver-.+$/i
        ]
      },
      {
        target: '/products/cloak-shells',
        patterns: [
          /^\/products\/cloak-shells?-for-.+$/i
        ]
      },
      {
        target: '/products/cloak-hook-and-loop-holster',
        patterns: [
          /^\/products\/cloak-hook-and-loop-holster-for-.+$/i,
          /^\/products\/cloak-hook-and-loop-for-.+$/i,
          /^\/products\/cloak-hook-for-.+$/i,
          /^\/products\/cloak-hook-and-loop-holster-.+$/i,
          /^\/products\/cloak-hook-and-loop-.+$/i,
          /^\/products\/cloak-hook-.+$/i
        ]
      },
      {
        target: '/products/cloak-belt-holster',
        patterns: [
          /^\/products\/cloak-belt-holster-for-.+$/i,
          /^\/products\/cloak-belt-for-.+$/i,
          /^\/products\/cloak-belt-holster-.+$/i,
          /^\/products\/cloak-belt-.+$/i
        ]
      },
      {
        target: '/products/cloak-swivel-drop-leg-holster',
        patterns: [
          /^\/products\/cloak-swivel-drop-leg-holster-for-.+$/i,
          /^\/products\/cloak-swivel-drop-leg-for-.+$/i,
          /^\/products\/cloak-swivel-drop-leg-holster-.+$/i,
          /^\/products\/cloak-swivel-drop-leg-.+$/i
        ]
      },
      {
        target: '/products/cloak-tuck-3-0-revolver-holsters',
        patterns: [
          /^\/products\/cloak-tuck-3-0-revolver-holsters?-for-.+$/i,
          /^\/products\/cloak-tuck-3-0-revolver-for-.+$/i,
          /^\/products\/cloak-tuck-3-0-for-.+$/i,
          /^\/products\/cloak-tuck-3-0-revolver-holsters?-.+$/i,
          /^\/products\/cloak-tuck-3-0-.+$/i
        ]
      },
      {
        target: '/products/cloak-owb-paddle-holster',
        patterns: [
          /^\/products\/cloak-owb-paddle-holster-for-.+$/i,
          /^\/products\/cloak-owb-paddle-for-.+$/i,
          /^\/products\/cloak-paddle-holster-for-.+$/i,
          /^\/products\/cloak-paddle-for-.+$/i,
          /^\/products\/cloak-owb-paddle-holster-.+$/i,
          /^\/products\/cloak-owb-paddle-.+$/i,
          /^\/products\/cloak-paddle-holster-.+$/i,
          /^\/products\/cloak-paddle-.+$/i
        ]
      }
    ];

    // Find the first matching redirect rule
    for (const rule of redirectMap) {
      if (currentPath === rule.target) continue; // Already at the target URL

      // Check if current path is excluded from this rule
      if (rule.exclude && rule.exclude.some(exPattern => exPattern.test(currentPath))) {
        continue;
      }

      const matches = rule.patterns.some(pattern => pattern.test(currentPath));
      if (matches) {
        window.location.replace(rule.target);
        break; // Stop evaluating rules once redirected
      }
    }
  } catch (e) {
    console.error('Cloak redirects error:', e);
  }
})();
